import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { AddCompanyRequest } from '../models/request/company/AddCompanyRequest';
import { GetCompanyListPagingAndFilterRequest } from '../models/request/company/GetCompanyListPagingAndFilterRequest';
import { GetCompanyListRequest } from '../models/request/company/GetCompanyListRequest';

export class CompanyService {
    static async getCompanyListPagingAndFilter(inputObj: GetCompanyListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - getCompanyList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Company/GetCompanyListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getCompanyList(inputObj: GetCompanyListRequest) {
        try {
            console.log('SERVICE CALL - getCompanyList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Company/getCompanyList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async changeCompanyInitialCompanyType(_companyId: string, _initialCompanyTypeId: string) {
        try {
            var inputObj = {
                companyId: _companyId,
                initialCompanyTypeId: _initialCompanyTypeId
            };

            console.log('SERVICE CALL - changeCompanyInitialCompanyType', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Company/changeCompanyInitialCompanyType', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addCompany(inputObj: AddCompanyRequest) {
        try {
            const formData = this.getFormData(inputObj);

            console.log('SERVICE CALL - AddCompany', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Company/AddCompany', formData);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static getFormData(obj: any = {}, formData = new FormData(), key = '') {
        if (!([Array, File, Object].includes(obj.constructor))) {
            return formData;
        }

        // Handle File recursive
        if (obj instanceof File) {
            formData.append(key, obj);
            return formData;
        }

        for (const prop in obj) {
            // Validate value type
            if (obj[prop] && !([String, Number, Boolean, Array, Object, File].includes(obj[prop].constructor))) {
                continue;
            }

            // Set deep index of prop
            const deepKey = key ? key + `.${prop}` : prop;

            // Handle array
            if (Array.isArray(obj[prop])) {
                obj[prop].forEach((item: any, index: any) => {
                    this.getFormData(item, formData, `${deepKey}[${index}]`);
                })
                continue;
            }

            (typeof obj[prop] === 'object' && obj[prop] && obj[prop].constructor === Object)
                ? this.getFormData(obj[prop], formData, deepKey) // Handle object
                : formData.append(deepKey, [undefined, null].includes(obj[prop]) ? '' : obj[prop]) // Handle string, number, boolean
        }

        return formData;
    }

    static async deleteCompany(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteCompany', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Company/deleteCompany', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getCompanyById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getCompanyById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Company/getCompanyById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportCompanyList(inputObj: GetCompanyListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportCompanyList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Company/exportCompanyList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}